export default __webpack_public_path__ + "static/media/004-smart house.af14812a.svg";